import script from "./rohsConformityDeclarationsAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./rohsConformityDeclarationsAdd.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__